import { getI18nFromGeneral } from '@/src/tools/tools';
import { get } from 'lodash';
import { handleError } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';

const validateSlug = (slugValid) => {
  if (!slugValid) {
    return handleError([getI18nFromGeneral('general.error.sameurlslugexists')]);
  }
};

const validateSeoSetting = (seoSetting) => {
  return validateSlug(get(seoSetting, 'slugValid'));
};
export { validateSeoSetting, validateSlug };
